import { Outlet } from "react-router-dom";
import { cn } from "@/lib/utils";

const MOF_LOGO_SRC = "/assets/logos/mof-logo.png";

// Visual shell only. The guest-only guard (PublicRoute) is applied per-route in
// AuthRoutes so link/token flows (reset-password, forgot-password, sso) remain
// reachable while signed in — only the sign-in pages redirect authenticated users.
export default function AuthLayout() {
  return (
    <main className="min-h-screen bg-muted/30">
      <div
        className={cn(
          "container element-center min-h-screen flex-col gap-8 py-10",
        )}
      >
        <img
          src={MOF_LOGO_SRC}
          alt="وزارة المالية"
          className="h-16 w-auto object-contain sm:h-20"
        />
        <Outlet />
      </div>
    </main>
  );
}
